import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedLibraryService } from '../../../../petszel-shared/src/lib/services/shared.config';
import { Observable } from 'rxjs';
import { LocalProviderModel } from "../../../../petszel-shared/src/lib/shared-models/local-provider.model";
@Injectable({
  providedIn: 'root'
})
export class LocalPartnerSearchService {
  public token = localStorage.getItem('token');
  public headers: HttpHeaders;

  constructor(private http: HttpClient,
    private sharedLibraryService: SharedLibraryService) {
    if (this.token) {
      this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    } else {
      this.headers = new HttpHeaders();
    }
   }

   getPartnerCategories(){
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get(apiUrl + 'PetszelConstants/PartnerCategories', { headers: this.headers });
   }

   getShelterPartners(accountId: string) {
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get(apiUrl + `Staff/Shelters/${accountId}/Partners`, { headers: this.headers });
  }

   getShelters() {
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get(apiUrl + 'Staff/Shelters/Onboarded?page=1&count=500', { headers: this.headers });
   }

   getShelter(accountId: string){
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get(apiUrl + `Staff/Shelters/${accountId}`, { headers: this.headers });
   }

   updateShelterPartner(accountId: string, partner: any): Observable<any> {
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.put(apiUrl + `Staff/Shelters/${accountId}/Partners`, partner, { headers: this.headers });
  }

   postShelterPartners(accountId: string, partner: any){
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.post(apiUrl + `Staff/Shelters/${accountId}/Partners`, partner, { headers: this.headers });
   }

   deletePartner(accountId: string, partnerId: string){
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.delete(apiUrl + `Staff/Shelters/${accountId}/Partners?partnerId=${partnerId}`, { headers: this.headers });
   }

   getShelterCategory(){
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get(apiUrl + `Owner/Shelter/Partners`, { headers: this.headers });
   }

   getLocalProvidersCount(): Observable<number> {
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get<number>(apiUrl + 'Owner/LocalProviders/Count', { headers: this.headers });
   }

   getLocalProviders(page: number, count: number): Observable<LocalProviderModel[]> {
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.get<LocalProviderModel[]>(apiUrl + 'Owner/LocalProviders', { headers: this.headers, params: { page, count } });
   }

   storeBookingAppointmentEvent(data: any): Observable<any> {
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    return this.http.post<any>(apiUrl + 'Owner/BookingLinkEvent', data, { headers: this.headers });
   }
}
